import { render, staticRenderFns } from "./LoadingMini.vue?vue&type=template&id=2da7b0c6&scoped=true&"
import script from "./LoadingMini.vue?vue&type=script&lang=js&"
export * from "./LoadingMini.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMini.vue?vue&type=style&index=0&id=2da7b0c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da7b0c6",
  null
  
)

export default component.exports